import React from 'react';
import { createRoot } from 'react-dom/client';
import ProSubscriberMoreProArticles from '../../src/pro_subscriber/pro_subscriber_more_pro_articles/pro_subscriber_more_pro_articles';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('more-pro-articles-react-app');
  if (!container) return null;
  const root = createRoot(container);

  root.render(
    <DevexHighOrderComponent>
      <ProSubscriberMoreProArticles
        idsToExcludeFromRequest={JSON.parse(container.dataset.idsToExcludeFromRequest)}
        proMembershipAccessLevelId={container.dataset.proMembershipAccessLevelId}
      />
    </DevexHighOrderComponent>
  );
});
